module.exports = __webpack_public_path__ + "img/logo.44f8cd04.png";